import {Page} from './Page.js';

class Scroll
{
	constructor ()
	{
		console.log('Scroll');

		let iPos = 0;
		this.$window = Page.getWindow();
		this.$header = (Page.getBody()).find('> header');

		this.$window.on('scroll', this.checkPosition.bind(this));
		this.checkPosition();
	}

	checkPosition ()
	{
		let iPos = this.$window.scrollTop();
		if ( iPos > 0 && !this.$header.hasClass('is-scrolled') )
		{
			this.$header.addClass('is-scrolled');
		}
		else if ( iPos <= 0 && this.$header.hasClass('is-scrolled') )
		{
			this.$header.removeClass('is-scrolled');
		}
	}

}

export {Scroll};